let swiperInstances = [];
function initializeSwiper(element) {
  let swiperInstance = null;
  swiperInstance = new Swiper(element, {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
       460: {
          slidesPerView: 1
      },
      461: {
          slidesPerView: 2.55
      },
      769: {
          slidesPerView: 3.012
      },
      1025: {
          slidesPerView: 4.186
      },
      1500: {
          slidesPerView: 4.18
      },
  },
    navigation: {
      nextEl: element.closest('section').querySelector(".swiper-button-next"),
      prevEl: element.closest('section').querySelector(".swiper-button-prev"),
    }
  });
  swiperInstances.push(swiperInstance);
}
for (const element of document.querySelectorAll('.js-real-people-carousel')) {
  console.log(element, 'element')
  initializeSwiper(element);
}
  function destroySwipers() {
    for (const swiperInstance of swiperInstances) {
      if (swiperInstance) {
        swiperInstance.destroy();
      }
    }
    swiperInstances = [];
  }
